import React from "react"
import AllAppsImg from "./All-Apps-Transparent.png"
import Article from "./Article"
import EmptyBlock from "./EmptyBlock"
import styles from "./BannerHome.module.scss"
import BannerContainer from "@components/BannerContainer"

const BannerHome = props => {
  return (
    <BannerContainer
      renderLeftWrapperChildren={() => {
        return (
          <React.Fragment>
            <Article />
            <EmptyBlock className={styles.emptyBlockLeft} />
          </React.Fragment>
        )
      }}
      renderRightWrapperChildren={() => {
        return (
          <React.Fragment>
            <img
              src={AllAppsImg}
              alt="Apple Mac Book Laptop"
              className={styles.macbook + " align-items-baseline"}
            />
            <EmptyBlock className={styles.emptyBlockRight} />
          </React.Fragment>
        )
      }}
    />
  )
}

export default BannerHome
